/* eslint-disable import/no-cycle */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import '@/libs/sweet-alerts'
import { axiosInsNoEnc } from '@/libs/axios'
import axios from 'axios'
import { toDecrypt } from '@/libs/secret'

Vue.use(VueRouter)

const notAvailable = message => {
  Vue.swal({
    title: 'Sorry!',
    text: message,
    icon: 'warning',
    confirmButtonText: 'OK, I understood',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    buttonsStyling: false,
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
  routes: [
    {
      path: '/login',
      name: 'auth-username',
      component: () => import('@/views/page/auth/withUsername.vue'),
      meta: {
        pageTitle: 'Login',
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/auth-password',
      name: 'auth-password',
      component: () => import('@/views/page/auth/withPassword.vue'),
      meta: {
        pageTitle: 'Login',
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/register',
      name: 'auth-register',
      component: () => import('@/views/page/auth/register.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
        pageTitle: 'Register',
      },
    },
    {
      path: '/landing',
      name: 'landing',
      component: () => import('@/views/landing/Home.vue'),
      meta: {
        layout: 'horizontal',
        // resource: 'Auth',
        // redirectIfLoggedIn: true,
        pageTitle: 'Landing Page',
      },
    },
    {
      path: '/',
      name: 'home',
      // component: () => import('@/views/page/dashboard/Admin.vue'),
      // meta: {
      //   pageTitle: 'Dashboard',
      //   requiresAuth: true,
      //   breadcrumb: [
      //     {
      //       text: 'Home',
      //       active: true,
      //     },
      //   ],
      // },
      component: () => import('@/views/landing/Home.vue'),
      meta: {
        layout: 'horizontal',
        // resource: 'Auth',
        // redirectIfLoggedIn: true,
        pageTitle: 'Landing Page',
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/page/dashboard/Admin.vue'),
      meta: {
        pageTitle: 'Dashboard',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/campaign',
      component: () => import('@/views/page/Layout.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'manage',
          name: 'manage-campaign',
          component: () => import('@/views/page/campaign/Manage.vue'),
          meta: {
            pageTitle: 'Campaign',
            requiresAuth: true,
            breadcrumb: [
              {
                text: 'Manage Campaign',
                active: true,
              },
            ],
          },
        },
        {
          path: 'create',
          name: 'create-campaign',
          component: () => import('@/views/page/campaign/CreateCampaign.vue'),
          meta: {
            pageTitle: 'Create Campaign',
            requiresAuth: true,
            breadcrumb: [
              {
                text: 'Create Campaign',
                active: true,
              },
            ],
          },
        },
        {
          path: 'manage-template',
          name: 'manage-template',
          component: () => import('@/views/page/campaign/ManageTemplate.vue'),
          meta: {
            pageTitle: 'Create Template ID',
            requiresAuth: true,
            breadcrumb: [
              {
                text: 'Create Template ID',
                active: true,
              },
            ],
          },
        },
        {
          path: 'create-template',
          name: 'create-template',
          component: () => import('@/views/page/campaign/CreateTemplateID.vue'),
          meta: {
            pageTitle: 'Create Template',
            requiresAuth: true,
            breadcrumb: [
              {
                text: 'Create Template',
                active: true,
              },
            ],
          },
        },
        {
          path: 'view/:id',
          name: 'view-campaign',
          component: () => import('@/views/page/campaign/detail/Campaign.vue'),
          meta: {
            pageTitle: 'View Campaign',
            requiresAuth: true,
            navActiveLink: 'manage-campaign',
            breadcrumb: [
              {
                text: 'View Company Detail',
                active: true,
              },
            ],
          },
        },
        // {
        //   path: 'approve',
        //   name: 'approve-campaign',
        //   component: () => import('@/views/page/campaign/Approve.vue'),
        //   meta: {
        //     pageTitle: 'Approval Campaign',
        //     requiresAuth: true,
        //     breadcrumb: [
        //       {
        //         text: 'View Campaign Detail',
        //         active: true,
        //       },
        //     ],
        //   },
        // },
        {
          path: 'approval/:id',
          name: 'approval-view',
          component: () => import('@/views/page/campaign/detail/Approval.vue'),
          meta: {
            pageTitle: 'Approval Campaign Detail',
            requiresAuth: true,
            navActiveLink: 'manage-campaign',
            breadcrumb: [
              {
                text: 'View Company Detail',
                active: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: '/report',
      name: 'report',
      component: () => import('@/views/page/report/List.vue'),
      meta: {
        pageTitle: 'Report',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'List Reports',
            active: true,
          },
        ],
      },
    },
    // {
    //   path: '/open-auction',
    //   name: 'open-auction',
    //   component: () => import('@/views/page/auction/Open.vue'),
    //   meta: {
    //     pageTitle: 'Auction',
    //     requiresAuth: true,
    //     breadcrumb: [
    //       {
    //         text: 'Open Auction',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/auction-won',
    //   name: 'auction-won',
    //   component: () => import('@/views/page/auction/Won.vue'),
    //   meta: {
    //     pageTitle: 'Auction',
    //     requiresAuth: true,
    //     breadcrumb: [
    //       {
    //         text: 'Auction Won',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/history',
    //   name: 'history',
    //   component: () => import('@/views/page/auction/History.vue'),
    //   meta: {
    //     pageTitle: 'Auction',
    //     requiresAuth: true,
    //     breadcrumb: [
    //       {
    //         text: 'History',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    {
      path: '/realtime-bidding',
      name: 'realtime-bidding',
      component: () => import('@/views/page/auction/List.vue'),
      meta: {
        pageTitle: 'Auction',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Auction',
            active: true,
          },
        ],
      },
    },
    {
      path: '/budget',
      name: 'budget',
      component: () => import('@/views/page/finance/BudgetHistory.vue'),
      meta: {
        pageTitle: 'Finance',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Budget',
            active: true,
          },
        ],
      },
    },
    {
      path: '/budget/view/:id',
      name: 'budget-view',
      component: () => import('@/views/page/finance/BudgetHistoryView.vue'),
      meta: {
        pageTitle: 'Finance',
        requiresAuth: true,
        navActiveLink: 'budget',
        breadcrumb: [
          {
            text: 'Budget',
            active: true,
          },
        ],
      },
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: () => import('@/views/page/finance/Invoice.vue'),
      meta: {
        pageTitle: 'Finance',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Invoice',
            active: true,
          },
        ],
      },
    },
    {
      path: '/invoice/view/:id',
      name: 'invoice-view',
      component: () => import('@/views/page/finance/InvoiceView.vue'),
      meta: {
        pageTitle: 'Finance',
        requiresAuth: true,
        navActiveLink: 'invoice',
        breadcrumb: [
          {
            text: 'Invoice',
            active: true,
          },
        ],
      },
    },
    {
      path: '/topup/view/:id',
      name: 'topup-view',
      component: () => import('@/views/page/finance/TopupView.vue'),
      meta: {
        pageTitle: 'Finance',
        requiresAuth: true,
        navActiveLink: 'topup-credit',
        breadcrumb: [
          {
            text: 'Topup',
            active: true,
          },
        ],
      },
    },
    {
      path: '/topup-credit',
      name: 'topup-credit',
      component: () => import('@/views/page/finance/TopupCredit.vue'),
      meta: {
        pageTitle: 'Finance',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Topup Credit',
            active: true,
          },
        ],
      },
    },
    {
      path: '/rate-card',
      name: 'rate-card',
      component: () => import('@/views/page/rate-card/List.vue'),
      meta: {
        pageTitle: 'Rate Card',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'List Rate Card',
            active: true,
          },
        ],
      },
    },
    {
      path: '/domain',
      name: 'domain',
      component: () => import('@/views/page/domain/List.vue'),
      meta: {
        pageTitle: 'Domain',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'List Domain',
            active: true,
          },
        ],
      },
    },
    {
      path: '/account',
      component: () => import('@/views/page/Layout.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'approval',
          name: 'account-approval',
          component: () => import('@/views/page/account/Approval.vue'),
          meta: {
            pageTitle: 'Account',
            requiresAuth: true,
            breadcrumb: [
              {
                text: 'New Partner Approval',
                active: true,
              },
            ],
          },
        },
        {
          path: 'approval/view/:id',
          name: 'account-view-approval',
          component: () => import('@/views/page/account/detail/Company.vue'),
          meta: {
            pageTitle: 'Account',
            requiresAuth: true,
            navActiveLink: 'account-approval',
            breadcrumb: [
              {
                text: 'View Company Detail',
                active: true,
              },
            ],
          },
        },
        {
          path: 'partner',
          name: 'account-partner',
          component: () => import('@/views/page/account/Partner.vue'),
          meta: {
            pageTitle: 'Account',
            requiresAuth: true,
            breadcrumb: [
              {
                text: 'Partner Listings',
                active: true,
              },
            ],
          },
        },
        {
          path: 'partner/view/:id',
          name: 'account-view-partner',
          component: () => import('@/views/page/account/detail/CompanyPartner.vue'),
          meta: {
            pageTitle: 'Account',
            requiresAuth: true,
            navActiveLink: 'account-partner',
            breadcrumb: [
              {
                text: 'View Company Detail',
                active: true,
              },
            ],
          },
        },
        {
          path: 'access',
          name: 'account-access',
          component: () => import('@/views/page/account/Access.vue'),
          meta: {
            pageTitle: 'Account',
            requiresAuth: true,
            breadcrumb: [
              {
                text: 'Access Management',
                active: true,
              },
            ],
          },
        },
        {
          path: 'company',
          name: 'account-company',
          component: () => import('@/views/page/account/Company.vue'),
          meta: {
            pageTitle: 'Account',
            requiresAuth: true,
            breadcrumb: [
              {
                text: 'My Company',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user',
          name: 'account-user',
          component: () => import('@/views/page/account/Profile.vue'),
          meta: {
            pageTitle: 'Account',
            requiresAuth: true,
            breadcrumb: [
              {
                text: 'My Account',
                active: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: '/inbox',
      name: 'inbox',
      component: () => import('@/views/page/inbox/List.vue'),
      meta: {
        pageTitle: 'Inbox',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'List Inbox',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tools',
      name: 'cs-tools',
      component: () => import('@/views/page/tools/WhiteList.vue'),
      meta: {
        pageTitle: 'Tools',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'CS Tools',
            active: true,
          },
        ],
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/lnk/*',
      component: () => import('@/views/landing/LinkShort.vue'),
      meta: {
        pageTitle: 'Redirect..',
        layout: 'full',
      },
    },
    {
      path: '/terms',
      name: 'page-terms',
      component: () => import('@/views/landing/Terms.vue'),
      meta: {
        pageTitle: 'Terms',
        layout: 'horizontal',
      },
    },
    // {
    //   path: '/welcome',
    //   name: 'splash',
    //   component: () => import('@/views/page/splash/Start.vue'),
    //   meta: {
    //     pageTitle: 'Terms',
    //     layout: 'full',
    //   },
    // },
    {
      path: '/regulation',
      name: 'page-regulation',
      component: () => import('@/views/landing/Regulations.vue'),
      meta: {
        pageTitle: 'Regulation',
        layout: 'horizontal',
      },
    },
    {
      path: '/channel-sms',
      name: 'channel-sms',
      component: () => import('@/views/landing/ChannelSms.vue'),
      meta: {
        pageTitle: 'Channel',
        layout: 'horizontal',
      },
    },
    {
      path: '/channel-ussd',
      name: 'ussd-747',
      component: () => import('@/views/landing/ChannelUssd.vue'),
      meta: {
        pageTitle: 'Channel',
        layout: 'horizontal',
      },
    },
    {
      path: '/channel-flash',
      name: 'flash-message',
      component: () => import('@/views/landing/ChannelFlash.vue'),
      meta: {
        pageTitle: 'Channel',
        layout: 'horizontal',
      },
    },
    {
      path: '/channel-digiads',
      name: 'channel-digiads',
      component: () => import('@/views/landing/ChannelDigiads.vue'),
      meta: {
        pageTitle: 'Channel',
        layout: 'horizontal',
      },
    },
    {
      path: '/channel-bima+',
      name: 'channel-bima+',
      component: () => import('@/views/landing/ChannelBimaPlus.vue'),
      meta: {
        pageTitle: 'Channel',
        layout: 'horizontal',
      },
    },
    {
      path: '/user-guideline',
      name: 'user-guide',
      component: () => import('@/views/guide/Main.vue'),
      meta: {
        layout: 'horizontal',
      },
      children: [
        {
          path: ':page',
          name: 'user-guideline',
          component: () => import('@/views/guide/PageView.vue'),
          meta: {
            pageTitle: 'User Guideline',
            layout: 'horizontal',
            navActiveLink: 'user-guide',
            // breadcrumb: [
            //   {
            //     text: 'Manage Campaign',
            //     active: true,
            //   },
            // ],
          },
        },
      ],
    },
    {
      path: '/guadlines',
      name: 'page-guadlines',
      component: () => import('@/views/page/Guadlines.vue'),
      meta: {
        pageTitle: 'Guadlines',
        layout: 'full',
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  // if (to.name === 'home') {
  //   if (localStorage.getItem('firstAccess') === '1' || localStorage.getItem('firstAccess') === null) {
  //     next({
  //       path: '/welcome',
  //     })
  //   } else {
  //     next()
  //   }
  // }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/getUserData'] || !store.state.auth.userData) {
      next({
        path: '/login',
      })
    } else {
      const dept = store.state.auth.userData.data.departement.id
      const role = store.state.auth.userData.data.Account.role_id
      // const role = store.state.auth.userData.data.role
      // console.log(to.name, role, dept)
      if (dept !== 3) {
        store.dispatch('inbox/listInbox')
      }
      if ((dept === 2 || dept === 3 || dept === 4) && (to.name === 'topup-credit' || to.name === 'open-auction' || to.name === 'auction-won' || to.name === 'history' || to.name === 'approve-campaign')) {
        notAvailable('This features is not available for HOUSE Campaign users. For more details, please contact IOH Support.')
      } else if (role === 3 && (dept === 3 || dept === 4) && to.name === 'approval-view') {
        notAvailable('This features is not available in this moment. For more details, please contact IOH Support.')
      } else if (role === 3 && dept === 1 && to.name === 'cs-tools') {
        notAvailable('This features is not available for Campaign Analyst users. For more details, please contact IOH Support.')
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
